import React from 'react';
import { MessageCircleIcon } from 'lucide-react';
export function PharmacistConsultation() {
  return <div className="bg-blue-50 border-2 border-blue-200 rounded-xl p-6 shadow-sm" data-id="element-4845" data-mp="3933lko2gg0sf">
      <div className="flex items-start mb-4" data-id="element-4846" data-mp="2ue7dir0eenrt">
        <div className="bg-white rounded-full p-2 mr-3" data-id="element-4847" data-mp="2ufikt0t1ydno">
          <MessageCircleIcon className="w-6 h-6 text-blue-600" data-id="element-4848" data-mp="2zcirndxq7kfu" />
        </div>
        <div className="flex-1" data-id="element-4849" data-mp="3n2ms5cfmb42m">
          <h3 className="text-base font-bold text-gray-900 mb-2" data-id="element-4850" data-mp="3n2cynevd6es6">
            Need Help Choosing the Right Product?
          </h3>
          <p className="text-sm text-gray-700" data-id="element-4851" data-mp="3s0y3xsph3onh">
            You can consult a pharmacist directly to answer your inquiries
          </p>
        </div>
      </div>
      <button className="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-6 rounded-lg transition-colors flex items-center justify-center gap-2" data-id="element-4852" data-mp="3i2qq3iqhdmpp">
        <MessageCircleIcon className="w-5 h-5" data-id="element-4853" data-mp="21rmmxsrqyfpb" />
        Consult Pharmacist
      </button>
    </div>;
}